<template>
    <div class="container">
      <b-form @submit="onSubmit" class="login-form">
        <b-form-group  label="E-Mailadresse:" label-for="email">
          <b-form-input
            id="email"
            v-model="form.email"
            type="email"
            required
            placeholder=""
            :class="authenticationError ? 'is-invalid' : ''"
          ></b-form-input>
          <div class="invalid-feedback" v-if="authenticationError">{{ authenticationError }}</div>
        </b-form-group>


        <b-button type="submit" variant="primary" :disabled="resetting" class="btn-block mt-4">
            <span v-if="!resetting" class="d-flex align-items-center justify-content-between"><font-awesome-icon :icon="['far', 'arrow-right']" style="opacity: 0" />Neues Kennwort zuschicken<font-awesome-icon :icon="['far', 'arrow-right']" /></span>
            <span v-else><b-spinner small type="grow"></b-spinner> Kennwort wird erneuert...</span>
        </b-button>
        <!-- <b-button variant="primary" class="btn-block mt-3" disabled v-if="!resetting">
          <b-spinner small type="grow"></b-spinner>
          verifying your details...
        </b-button> -->
      </b-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'login',

    data() {
        return {
            form: {
                email: "",
                password: "",
            }
        };
    },

    computed: {
        ...mapGetters('auth', [
            'resetting',
            'authenticationError',
            'authenticationErrorCode'
        ])
    },

    methods: {
        ...mapActions('auth', [
            'resetpw'
        ]),

        onSubmit(e) {
            e.preventDefault()
            if (this.email != '') {
                this.resetpw({email: this.form.email})
            }
        }
    }
}
</script>

<style scoped>
.login-form {
    padding-top: 30px;
}
</style>